import styled, { keyframes } from "styled-components";

export const CardContainer = styled.div`
  cursor: pointer;
  width: 18.75rem;
  height: 13.5rem;
  overflow: hidden;
  background: var(--mainBlue);
  box-shadow: 0px 0px 15px -5px var(--mainShadow);
  transition: 0.5s;
  animation: ease-in;
  border-radius: 5%;
  margin: 1rem;
  span, h1{
      color: #29201e;
  }
  &:hover{
    background: var(--secondBlue);
    transform: scale(1.2);
    box-shadow: 0px 0px 40px -3px var(--secondShadow);
    span{
      color: #ffffff;
      transition: 0.3s;
      }
    
    h1{
      color: var(--thirdBlue);
      transition: 0.3s;
    }
  }
  @media (max-width: 769px) {
      margin: 0.5rem;
      width: 20rem;
      height: 9rem;
      background: var(--secondBlue);
  }
  @media (max-width: 1080px) {
      margin: 0.5rem;
      width: 20rem;
  }
`;

export const CardContent = styled.div`
  margin: 1rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  
`;

export const CardTitle = styled.h1`
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  color: var(--mainWhite);
  @media (max-width: 769px) {
    margin-bottom: 0.2rem;
    font-size: 1.2rem;
  }
  @media (max-width: 1080px) {
    margin-bottom: 0.3rem;
  }
`;

export const CardPercentage = styled.span`
  margin-bottom: 1.5rem;
  font-size: 4.5rem;
  color: var(--mainWhite);
  font-family: 'Roboto Slab';
  @media (max-width: 769px) {
    margin-bottom: 0.2rem;
    font-size: 1.5rem;
  }
  @media (max-width: 1080px) {
    margin-bottom: 0.2rem;
    font-size: 3.5rem;
  }
`;

export const CardAbsoluteValue = styled.h1`
  font-size: 2rem;
  color: var(--mainWhite);
  @media (max-width: 769px) {
    font-size: 1.2rem;
  }
`;

